"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReducedMotionSymbol = void 0;
exports.ReducedMotionSymbol = Symbol.for('reducedMotion');
//# sourceMappingURL=reducedMotion.js.map